import { create } from "zustand";

// "requests" is a client-side pinned view: it expands to
// type IN (feature_request, improvement) and is not sent as a backend tab.
type InboxTab = "todo" | "all" | "mine" | "unassigned" | "ai" | "requests";

interface InboxFilters {
  tab: InboxTab;
  status: string[];
  search: string;
  type: string | null;
  appArea: string | null;
}

interface InboxState {
  filters: InboxFilters;
  whisperMode: boolean;
  unreadCount: number;

  setFilters: (filters: Partial<InboxFilters>) => void;
  setTab: (tab: InboxTab) => void;
  setSearch: (search: string) => void;
  setWhisperMode: (whisperMode: boolean) => void;
  toggleWhisperMode: () => void;
  setUnreadCount: (count: number) => void;
  reset: () => void;
}

const initialFilters: InboxFilters = {
  tab: "todo",
  status: [],
  search: "",
  type: null,
  appArea: null,
};

const initialState = {
  filters: initialFilters,
  whisperMode: false,
  unreadCount: 0,
};

export const useInboxStore = create<InboxState>((set) => ({
  ...initialState,

  setFilters: (partial: Partial<InboxFilters>) =>
    set((state) => ({
      filters: { ...state.filters, ...partial },
    })),

  setTab: (tab: InboxTab) =>
    set((state) => ({
      filters: { ...state.filters, tab },
    })),

  setSearch: (search: string) =>
    set((state) => ({
      filters: { ...state.filters, search },
    })),

  setWhisperMode: (whisperMode: boolean) => set({ whisperMode }),

  toggleWhisperMode: () =>
    set((state) => ({ whisperMode: !state.whisperMode })),

  setUnreadCount: (count: number) => set({ unreadCount: count }),

  reset: () => set({ ...initialState }),
}));
